import { useState, useEffect } from 'react';
import { usePublishersStore } from '../../../store/models';

function useEcalWorldProfile (props) {
    const { publisher } = props;
    const publishersStore = usePublishersStore();

    const [isPublic, setIsPublic] = useState(publisher.publicAccess === true);
    const [confirmOpen, setConfirmOpen] = useState(false);

    useEffect(() => {
        setIsPublic(publisher.publicAccess === true);
    }, [publisher.publicAccess]);

    const tooltipTitle = isPublic
        ? 'Your organisation is discoverable in ECAL World — click to disable'
        : 'Make your organisation discoverable in ECAL World';

    const dialogTitle = isPublic ? 'Disable ECAL World Discoverability' : 'Enable ECAL World Discoverability';

    const dialogText = isPublic
        ? 'Are you sure you want to make your organisation undiscoverable in ECAL World?'
        : 'Are you sure you want to make your organisation discoverable in ECAL World?';

    function handleToggle (e) {
        e.stopPropagation();
        e.preventDefault();
        setConfirmOpen(true);
    }

    function handleConfirm () {
        const newValue = !isPublic;
        setIsPublic(newValue);
        publishersStore.updatePublisherDetails({ publicAccess: newValue });
        setConfirmOpen(false);
    }

    function handleCancel () {
        setConfirmOpen(false);
    }

    return {
        isPublic,
        confirmOpen,
        tooltipTitle,
        dialogTitle,
        dialogText,
        handleToggle,
        handleConfirm,
        handleCancel,
    };
}

export default useEcalWorldProfile;
